import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "color", "fontSize", "paddingBlock", "paddingBlockEnd", "paddingBlockStart", "paddingInline", "paddingInlineEnd", "paddingInlineStart", "marginBlockEnd", "marginBlockStart", "marginInlineEnd", "marginInlineStart"];
import { Text } from 'foundations-components/components/Text';
import { useTypographyProps } from './useTypographyProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const Body = _ref => {
  let {
      as = 'p',
      children,
      color,
      fontSize = 'base',
      paddingBlock,
      paddingBlockEnd,
      paddingBlockStart,
      paddingInline,
      paddingInlineEnd,
      paddingInlineStart,
      marginBlockEnd,
      marginBlockStart,
      marginInlineEnd,
      marginInlineStart
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    typographyProps
  } = useTypographyProps({
    color,
    fontSize,
    paddingBlock,
    paddingBlockEnd,
    paddingBlockStart,
    paddingInline,
    paddingInlineEnd,
    paddingInlineStart,
    marginBlockEnd,
    marginBlockStart,
    marginInlineEnd,
    marginInlineStart
  });
  return /*#__PURE__*/_jsx(Text, Object.assign({}, rest, {
    as: as
  }, typographyProps, {
    children: children
  }));
};